import React, { useState, useEffect } from "react";
import abacusStudent from "../images/abacusStudents.jpeg";
import inquiryImage from "../images/enquiryImg.jpg";
import Header from "./Header";
import Footer from "./Footer";
import axios from "axios";
import { Constant } from "../helper/Constants";

const AbacusNearMe = () => {
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [schoolData, setSchoolData] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getSchoolData();
  }, []);
  const getSchoolData = async () => {
    try {
      axios.get(Constant.getUrls.getAllAbacusCourses).then((resp) => {
        console.log(resp);
        setSchoolData(resp.data.data);
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Header />

      {/* ===================== MODAL INCLUDED HERE ===================== */}
      {open && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              width: isMobile ? "90%" : "450px",
              background: "#fff",
              padding: "25px 30px",
              borderRadius: "12px",
              position: "relative",
              boxShadow: "0px 8px 20px rgba(0,0,0,0.2)",
            }}
          >
            <span
              onClick={() => setOpen(false)}
              style={{
                position: "absolute",
                right: "18px",
                top: "18px",
                cursor: "pointer",
                fontSize: "20px",
                fontWeight: "bold",
              }}
            >
              ✕
            </span>

            <h2 style={{ fontSize: "22px", marginBottom: "20px" }}>
              STUDENT INQUIRY
            </h2>

            <input placeholder="Enter Name" style={inputStyle} />
            <input placeholder="Enter Email Id" style={inputStyle} />
            <input placeholder="Enter Contact No" style={inputStyle} />
            <input placeholder="Enter Your City" style={inputStyle} />

            <div style={{ display: "flex", gap: "10px" }}>
              <select style={{ ...inputStyle, width: "50%" }}>
                <option>India</option>
              </select>
              <select style={{ ...inputStyle, width: "50%" }}>
                <option>Select State</option>
              </select>
            </div>

            <textarea
              placeholder="Your Remarks / Comments"
              style={{ ...inputStyle, height: "90px", resize: "none" }}
            />

            <div
              style={{
                marginTop: "10px",
                padding: "15px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <input type="checkbox" /> <span>I'm not a robot</span>
            </div>

            <p style={{ fontSize: "12px", marginTop: "12px", color: "#444" }}>
              By registering here, I agree to VASA-Abacus Abacus Terms &
              Conditions and Privacy Policy
            </p>

            <button
              style={{
                backgroundColor: "#29166e",
                color: "#fff",
                padding: "12px 26px",
                borderRadius: "5px",
                border: "none",
                width: "100%",
                marginTop: "20px",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              SUBMIT
            </button>
          </div>
        </div>
      )}
      {/* ===================== END MODAL ===================== */}

      {/* ================= HERO SECTION ================= */}
      <div
        style={{
          width: "100%",
          height: isMobile ? "auto" : "600px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${abacusStudent})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            zIndex: 1,
          }}
        />

        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(to bottom, #29166e, #ffffff)",
            opacity: 0.85,
            zIndex: 2,
          }}
        />

        <div
          style={{
            position: "relative",
            zIndex: 3,
            padding: "60px 6%",
            color: "#fff",
          }}
        >
          <div style={{ maxWidth: isMobile ? "100%" : "50%" }}>
            <p style={{ fontSize: "22px", marginBottom: 10 }}>
              Skip long distance travels for <br /> learning Abacus
            </p>

            <h1
              style={{
                fontSize: isMobile ? "28px" : "38px",
                fontWeight: 700,
                lineHeight: "1.3",
                marginBottom: 30,
              }}
            >
              FIND <br />
              VASA-ABACUS ABACUS CLASSES <br />
              IN YOUR VICINITY
            </h1>

            <button
              onClick={() => setOpen(true)}
              style={{
                backgroundColor: "#29166e",
                color: "#fff",
                padding: "12px 28px",
                borderRadius: "5px",
                border: "none",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              RAISE AN INQUIRY
            </button>
          </div>
        </div>
      </div>

      {/* ================= INTRO SECTION ================= */}
      <div
        style={{
          padding: "60px 6%",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: "40px",
        }}
      >
        <div style={{ width: "100%" }}>
          <img
            src={inquiryImage}
            alt="Inquiry"
            style={{ width: "100%", borderRadius: "8px" }}
          />
        </div>

        <div style={{ width: "100%" }}>
          <h2
            style={{
              color: "#29166e",
              fontSize: "34px",
              marginBottom: "10px",
              fontWeight: 700,
            }}
          >
            ABACUS CLASSES NEAR ME <br />
            IS THIS WHAT YOU ARE SEARCHING FOR?
          </h2>

          <p style={{ fontSize: "18px", lineHeight: "1.6", color: "#444" }}>
            Abacus Classes near me, is this what you are searching for? Well,
            you are not the only one. There are many such Parents. But, finding
            a quality Abacus academy for a child is not easy, as parents are not
            aware of the intricacies of Abacus training & learning. When a child
            learns Abacus, parents expect improvement in their mental math
            abilities. In addition, they expect enhanced listening ability,
            visualization capacity, and concentration levels in their children.,
            They expect whole-brain development and increased confidence in the
            child. Also, overall performance in Academics should reflect their
            improved abilities Expected results can be achieved only in
            professionally managed classes by efficient Abacus Teachers trained
            by an organized and professional Abacus promoter like VASA-Abacus.
            Furthermore, VASA-Abacus's game-based program ensures the learning
            process does not become monotonous, which is very important for the
            expected results.
          </p>

          <button
            onClick={() => setOpen(true)}
            style={{
              backgroundColor: "#29166e",
              color: "#fff",
              padding: "12px 26px",
              borderRadius: "5px",
              border: "none",
              marginTop: "20px",
              cursor: "pointer",
              fontSize: "16px",
            }}
          >
            Raise An Inquiry
          </button>
        </div>
      </div>

      {/* ================= COURSE STRUCTURE ================= */}
      <div style={{ padding: "50px 6%", textAlign: "center" }}>
        <h1
          style={{
            fontSize: "40px",
            fontWeight: 800,
            marginBottom: "40px",
            color: "#29166e",
          }}
        >
          ABACUS COURSE STRUCTURE
        </h1>

        <div
          style={{
            display: "flex",
            gap: "30px",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          {schoolData.map((item) => (
            <div style={{ ...cardStyle, width: isMobile ? "100%" : "45%" }}>
              <h3 style={cardTitle}>{item?.title}</h3>
              <p style={cardText}>
                {item?.description.substring(0, 50)}
                <br />
                <br />
                <strong>{item?.duration}</strong>
              </p>
            </div>
          ))}
          {/* <div style={{ ...cardStyle, width: isMobile ? "100%" : "45%" }}>
            <h3 style={cardTitle}>
              VASA-ABACUS ABACUS PROGRAM (AGE 7 TO 12 YEARS)
            </h3>
            <p style={cardText}>
              An Abacus Math Program developed specially for children…
              <br />
              <br />
              <strong>Duration: 8 levels – twice a week</strong>
            </p>
          </div> */}

          {/* <div style={{ ...cardStyle, width: isMobile ? "100%" : "45%" }}>
            <h3 style={cardTitle}>LINGO BINGO (AGE 4 TO 6 YEARS)</h3>
            <p style={cardText}>
              A program to develop number sense through games…
              <br />
              <br />
              <strong>Duration: 3 to 6 months</strong>
            </p>
          </div> */}
        </div>
      </div>

      <Footer />
    </>
  );
};

const inputStyle = {
  width: "100%",
  padding: "12px",
  marginBottom: "12px",
  border: "none",
  borderBottom: "1px solid #aaa",
  outline: "none",
  fontSize: "14px",
};

const cardStyle = {
  background: "#fff",
  padding: "25px",
  borderRadius: "12px",
  boxShadow: "0 6px 18px rgba(0,0,0,0.1)",
  textAlign: "left",
};

const cardTitle = {
  color: "#29166e",
  marginBottom: "10px",
  fontSize: "20px",
  fontWeight: 700,
};

const cardText = {
  color: "#444",
  lineHeight: "1.6",
};

export default AbacusNearMe;

// import React, { useState } from "react";
// import abacusStudent from "../images/abacusStudents.jpeg";
// import inquiryImage from "../images/enquiryImg.jpg";
// import Header from "./Header";
// import Footer from "./Footer";

// const AbacusNearMe = () => {
//   const [open, setOpen] = useState(false);

//   return (
//     <>
//       <Header />

//       {/* ===================== MODAL INCLUDED HERE ===================== */}
//       {open && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             backgroundColor: "rgba(0,0,0,0.5)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 9999,
//           }}
//         >
//           <div
//             style={{
//               width: "450px",
//               background: "#fff",
//               padding: "25px 30px",
//               borderRadius: "12px",
//               position: "relative",
//               boxShadow: "0px 8px 20px rgba(0,0,0,0.2)",
//             }}
//           >
//             {/* CLOSE BUTTON */}
//             <span
//               onClick={() => setOpen(false)}
//               style={{
//                 position: "absolute",
//                 right: "18px",
//                 top: "18px",
//                 cursor: "pointer",
//                 fontSize: "20px",
//                 fontWeight: "bold",
//               }}
//             >
//               ✕
//             </span>

//             <h2 style={{ fontSize: "22px", marginBottom: "20px" }}>
//               STUDENT INQUIRY
//             </h2>

//             {/* INPUTS */}
//             <input placeholder="Enter Name" style={inputStyle} />
//             <input placeholder="Enter Email Id" style={inputStyle} />
//             <input placeholder="Enter Contact No" style={inputStyle} />
//             <input placeholder="Enter Your City" style={inputStyle} />

//             {/* COUNTRY + STATE */}
//             <div style={{ display: "flex", gap: "10px" }}>
//               <select style={{ ...inputStyle, width: "50%" }}>
//                 <option>India</option>
//               </select>

//               <select style={{ ...inputStyle, width: "50%" }}>
//                 <option>Select State</option>
//               </select>
//             </div>

//             {/* COMMENTS */}
//             <textarea
//               placeholder="Your Remarks / Comments"
//               style={{
//                 ...inputStyle,
//                 height: "90px",
//                 resize: "none",
//               }}
//             />

//             {/* reCAPTCHA placeholder */}
//             <div
//               style={{
//                 marginTop: "10px",
//                 padding: "15px",
//                 border: "1px solid #ccc",
//                 borderRadius: "6px",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "10px",
//               }}
//             >
//               <input type="checkbox" /> <span>I'm not a robot</span>
//             </div>

//             <p style={{ fontSize: "12px", marginTop: "12px", color: "#444" }}>
//               By registering here, I agree to VASA-Abacus Abacus Terms &
//               Conditions and Privacy Policy
//             </p>

//             <button
//               style={{
//                 backgroundColor: "#29166e",
//                 color: "#fff",
//                 padding: "12px 26px",
//                 borderRadius: "5px",
//                 border: "none",
//                 width: "100%",
//                 marginTop: "20px",
//                 cursor: "pointer",
//                 fontSize: "16px",
//                 fontWeight: "600",
//               }}
//             >
//               SUBMIT
//             </button>
//           </div>
//         </div>
//       )}
//       {/* ===================== END MODAL ===================== */}

//       {/* ================= HERO SECTION ================= */}
//       <div
//         style={{
//           width: "100%",
//           height: "600px",
//           position: "relative",
//           overflow: "hidden",
//           fontFamily: "sans-serif",
//         }}
//       >
//         {/* BACKGROUND IMAGE */}
//         <div
//           style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             backgroundImage: `url(${abacusStudent})`,
//             backgroundSize: "cover",
//             backgroundPosition: "center",
//             zIndex: 1,
//           }}
//         ></div>

//         {/* GRADIENT OVERLAY */}
//         <div
//           style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             background: "linear-gradient(to bottom, #29166e, #ffffff)",
//             opacity: 0.85,
//             zIndex: 2,
//           }}
//         ></div>

//         {/* CONTENT */}
//         <div
//           style={{
//             position: "relative",
//             zIndex: 3,
//             height: "100%",
//             display: "flex",
//             alignItems: "center",
//             padding: "0 6%",
//           }}
//         >
//           <div style={{ maxWidth: "50%", color: "#fff" }}>
//             <p style={{ fontSize: "22px", marginBottom: 10 }}>
//               Skip long distance travels for <br /> learning Abacus
//             </p>

//             <h1
//               style={{
//                 fontSize: "38px",
//                 fontWeight: 700,
//                 lineHeight: "1.3",
//                 marginBottom: 30,
//               }}
//             >
//               FIND <br />
//               VASA-ABACUS ABACUS CLASSES <br />
//               IN YOUR VICINITY
//             </h1>

//             <button
//               onClick={() => setOpen(true)}
//               style={{
//                 backgroundColor: "#29166e",
//                 color: "#fff",
//                 padding: "12px 28px",
//                 borderRadius: "5px",
//                 border: "none",
//                 cursor: "pointer",
//                 fontSize: "16px",
//                 fontWeight: "600",
//               }}
//             >
//               RAISE AN INQUIRY
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* ================= INTRO SECTION ================= */}
//       <div
//         style={{
//           padding: "60px 6%",
//           display: "flex",
//           justifyContent: "space-between",
//           gap: "40px",
//         }}
//       >
//         <div
//           style={{
//             width: "45%",
//             border: "2px solid #eee",
//             borderRadius: "8px",
//             padding: "10px",
//             boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//             background: "#fff",
//           }}
//         >
//           <img
//             src={inquiryImage}
//             alt="Inquiry"
//             style={{ width: "100%", borderRadius: "6px" }}
//           />
//         </div>

//         <div style={{ width: "55%" }}>
//           <h2
//             style={{
//               color: "#29166e",
//               fontSize: "34px",
//               marginBottom: "10px",
//               fontWeight: 700,
//             }}
//           >
//             ABACUS CLASSES NEAR ME <br />
//             IS THIS WHAT YOU ARE SEARCHING FOR?
//           </h2>

//           <p style={{ fontSize: "18px", lineHeight: "1.6", color: "#444" }}>
//             Abacus Classes near me, is this what you are searching for? Well,
//             you are not the only one. There are many such Parents. But, finding
//             a quality Abacus academy for a child is not easy, as parents are not
//             aware of the intricacies of Abacus training & learning. When a child
//             learns Abacus, parents expect improvement in their mental math
//             abilities. In addition, they expect enhanced listening ability,
//             visualization capacity, and concentration levels in their children.,
//             They expect whole-brain development and increased confidence in the
//             child. Also, overall performance in Academics should reflect their
//             improved abilities Expected results can be achieved only in
//             professionally managed classes by efficient Abacus Teachers trained
//             by an organized and professional Abacus promoter like VASA-Abacus.
//             Furthermore, VASA-Abacus's game-based program ensures the learning
//             process does not become monotonous, which is very important for the
//             expected results.
//           </p>

//           <button
//             onClick={() => setOpen(true)}
//             style={{
//               backgroundColor: "#29166e",
//               color: "#fff",
//               padding: "12px 26px",
//               borderRadius: "5px",
//               border: "none",
//               marginTop: "20px",
//               cursor: "pointer",
//               fontSize: "16px",
//             }}
//           >
//             Raise An Inquiry
//           </button>
//         </div>
//       </div>

//       {/* ================= COURSE STRUCTURE ================= */}
//       <div style={{ padding: "50px 6%", textAlign: "center" }}>
//         <h1
//           style={{
//             fontSize: "40px",
//             fontWeight: 800,
//             marginBottom: "40px",
//             color: "#29166e",
//           }}
//         >
//           ABACUS COURSE STRUCTURE
//         </h1>

//         <div
//           style={{
//             display: "flex",
//             gap: "30px",
//             justifyContent: "center",
//             flexWrap: "wrap",
//           }}
//         >
//           {/* CARD 1 */}
//           <div style={cardStyle}>
//             <h3 style={cardTitle}>
//               VASA-ABACUS ABACUS PROGRAM (AGE 7 TO 12 YEARS)
//             </h3>
//             <p style={cardText}>
//               An Abacus Math Program developed specially for children…
//               <br />
//               <br />
//               <strong>Duration: 8 levels – twice a week</strong>
//             </p>
//           </div>

//           {/* CARD 2 */}
//           <div style={cardStyle}>
//             <h3 style={cardTitle}>LINGO BINGO (AGE 4 TO 6 YEARS)</h3>
//             <p style={cardText}>
//               A program to develop number sense through games…
//               <br />
//               <br />
//               <strong>Duration: 3 to 6 months</strong>
//             </p>
//           </div>
//         </div>

//         <h2
//           style={{
//             marginTop: "60px",
//             fontSize: "32px",
//             color: "#29166e",
//             fontWeight: 700,
//           }}
//         >
//           Our Team will contact you with details of the nearest center.
//         </h2>

//         <button
//           onClick={() => setOpen(true)}
//           style={{
//             backgroundColor: "#29166e",
//             color: "#fff",
//             padding: "12px 35px",
//             borderRadius: "6px",
//             border: "none",
//             marginTop: "20px",
//             cursor: "pointer",
//             fontSize: "18px",
//           }}
//         >
//           Raise An Inquiry
//         </button>
//       </div>

//       <Footer />
//     </>
//   );
// };

// const inputStyle = {
//   width: "100%",
//   padding: "12px",
//   marginBottom: "12px",
//   border: "none",
//   borderBottom: "1px solid #aaa",
//   outline: "none",
//   fontSize: "14px",
// };

// const cardStyle = {
//   width: "45%",
//   background: "#fff",
//   padding: "25px",
//   borderRadius: "12px",
//   boxShadow: "0 6px 18px rgba(0,0,0,0.1)",
//   textAlign: "left",
// };

// const cardTitle = {
//   color: "#29166e",
//   marginBottom: "10px",
//   fontSize: "20px",
//   fontWeight: 700,
// };

// const cardText = {
//   color: "#444",
//   lineHeight: "1.6",
// };

// export default AbacusNearMe;
